import styled from "@yb/styled-px2rem";
import imgButton from "@PUBLIC/M/images/btn/btn_spr.png";

const Wrap = styled.div<{isHide: boolean}>`
	position: absolute;
	top: 0;
	left: 0;
	z-index: 5;
	display: flex;
	width: 100%;
	height: 100%;
	background-color: rgba(0, 0, 0, 0.5);
	align-items: center;
	justify-content: center;
	flex-direction: column;
	${props => props.isHide && "display: none;"}
`;

const Text = styled.p`
	width: 80%;
	color: #fff;
	word-break: break-word;
	line-height: 1.6;
	text-align: center;
`;

const CancelButton = styled.button`
	display: flex;
	margin-top: 22px;
	background-color: transparent;
	color: #fff;
	align-items: center;
	gap: 10px;

	&:before {
		display: inline-flex;
		width: 14px;
		height: 16px;
		background: transparent url(${imgButton}) 0 -16px / 100px 100px;
		content: "";
	}
`;

const CompareBox = ({state, onClick}) => (
	<Wrap isHide={!state}>
		<Text>비교할 상품을 선택해 주세요. 2개까지 선택하여 비교하실 수 있습니다.</Text>
		<CancelButton type="button" onClick={onClick}>
			다른상품 비교하기
		</CancelButton>
	</Wrap>
);

export default CompareBox;
